"use client";

import { datadogRum } from "@datadog/browser-rum";
import NextError from "next/error";
import { useEffect } from "react";

// docs には他の error boundary が無いため、ここがブラウザ側エラーの唯一の受け皿になる。
// Next.js が捕まえた時点で window.onerror へは届かないので、RUM へは明示的に送る。
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    datadogRum.addError(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* App Router はステータスコードを持たないため、汎用メッセージになる 0 を渡す。 */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
